import { BaseFirestoreService } from "../FirestoreService";
import { NewsStory, NEWS_COLLECTION } from "../../db/news";
import { NewsCommentsService } from "./NewsCommentsService";

/**
 * Shared News Service
 * Works with both Firebase Admin SDK (backend) and Client SDK (frontend)
 */
export class NewsService extends BaseFirestoreService<NewsStory> {
    protected getCollectionPath(): string {
        return NEWS_COLLECTION;
    }

    public newsCommentsService(newsId: string): NewsCommentsService {
        return new NewsCommentsService(this.firestore, newsId)
    }
}
